<script setup lang="ts">
import { Head, useForm } from '@inertiajs/vue3'
import LoginPassword from '@/Components/Auth/LoginPassword.vue'
import ValidationErrors from '@/Components/ValidationErrors.vue'
import { onMounted, ref } from 'vue'
import Button from '@/Components/Utils/Button.vue'
import { notify } from "@kyvg/vue3-notification"
import Layout from '@/Layouts/AuthLayout.vue'
import PureInput from '@/Components/Pure/PureInput.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faLock } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faUser, faLock)

defineOptions({ layout: Layout })

const form = useForm({
    username: '',
    password: '',
})

const isLoading = ref(false)

const submit = () => {
    isLoading.value = true
    form.post(route('auth.login'), {
        onError: (e) => {
            isLoading.value = false
            notify({
                title: "Login Gagal",
                text: e.message || 'Username atau password salah.',
                type: 'error',
            })
        },
        onSuccess: () => {
            form.reset('password')
        },
    })
}

const _inputUsername = ref(null)

onMounted(() => {
    // console.log('_inputUsername.value', _inputUsername.value)
    // console.log('_inputUsername.valuedsadasdsa', _inputUsername.value?._inputRef)
    _inputUsername.value?._inputRef.focus()
})
</script>

<template>
    <Head title="Login" />

    <form class="space-y-5" @submit.prevent="submit">
        <!-- Username -->
        <div class="space-y-1.5">
            <label class="block text-sm font-medium text-slate-300">
                Username
            </label>
            <div class="relative">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <FontAwesomeIcon icon="fal fa-user" class="text-slate-400 text-sm" fixed-width aria-hidden="true" />
                </div>
                <PureInput
                    ref="_inputUsername"
                    v-model="form.username"
                    @update:modelValue="() => form.errors.username = ''"
                    @keydown.enter="submit"
                    :isError="!!form.errors.username"
                    placeholder="Masukkan username..."
                    class="pl-9 bg-white/20 border-white/20"
                    classInput="text-white placeholder-slate-500 xfocus:border-sky-400 xfocus:ring-sky-400/20"
                />
            </div>
            <p v-if="form.errors.username" class="text-xs text-red-400">{{ form.errors.username }}</p>
        </div>

        <!-- Password -->
        <div class="space-y-1.5">
            <label class="block text-sm font-medium text-slate-300">
                Password
            </label>
            <div class="relative">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 z-10">
                    <FontAwesomeIcon icon="fal fa-lock" class="text-slate-400 text-sm" fixed-width aria-hidden="true" />
                </div>
                <LoginPassword
                    :form="form"
                    :showProcessing="false"
                    @keydown.enter="submit"
                    id="password"
                    name="password"
                    placeholder="Masukkan password..."
                    fieldName="password"
                    @update:modelValue="() => form.errors.password = ''"
                    :isError="!!form.errors.password"
                    inputClass="pl-12 bg-white/20 border-white/20 text-white placeholder-white/50 focus:ring-sky-400/20 focus:border-sky-400"
                    toggleClass="text-slate-300 bg-white/10 border-white/20 hover:bg-white/20 focus:ring-sky-400 focus:border-sky-400"
                />
            </div>
        </div>

        <!-- Submit -->
        <div class="pt-2">
            <Button
                full
                @click.prevent="submit"
                :loading="isLoading || form.processing"
                :disabled="isLoading || form.processing"
                label="Masuk"
                type="indigo"
                size="xl"
            />
        </div>
    </form>

    <ValidationErrors />
</template>
